import React, { useState } from 'react';
import {
  CREDENTIAL_LINK_TYPE,
  CREDENTIAL_LINK_MAP,
} from 'app/constants/profile';
import { credentialLinkIcons, credentialDropdownIcons } from 'theme';
import styled from 'styled-components';

const IconImage = styled.img`
  width: 29px;
  height: 29px;
  margin-right: 9px;
  margin-top: 5px;
  object-fit: contain;
`;

const LinkContainer = styled.div`
  cursor: pointer;

  > a svg:hover {
    fill: ${props => props.theme.colors.seedlyBlue};
  }

  [aria-label] {
    position: relative;
    font-size: 12px;
  }

  [aria-label]:hover:after {
    content: attr(aria-label);
    display: block;
    position: absolute;
    bottom: 130%;
    left: 0;
    z-index: 5000;
    pointer-events: none;
    padding: 5px 10px;
    white-space: nowrap;
    color: #fff;
    background-color: rgba(64, 72, 90, 0.9);
    border-radius: 2px;
  }
`;

const ProfileIconLink = props => {
  const { type, link } = props;
  const [hoverState, setHoverState] = useState(false);
  let url;

  const HighlightedIcon = credentialLinkIcons[type];
  const DefaultIcon = credentialDropdownIcons[type];
  const linkPrefix = CREDENTIAL_LINK_MAP[type];

  if (type === CREDENTIAL_LINK_TYPE.WEBSITE) {
    url = link.startsWith('http') ? link : `http://${linkPrefix}${link}`;
  } else {
    url = `http://${linkPrefix}${link}`;
  }

  return (
    <LinkContainer
      onMouseOver={() => setHoverState(true)}
      onMouseLeave={() => setHoverState(false)}
    >
      <a
        href={url}
        aria-label={url}
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        <IconImage src={hoverState ? HighlightedIcon : DefaultIcon} />
      </a>
    </LinkContainer>
  );
};

export default ProfileIconLink;
